/**
 * @prettier
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { getMultiSampleState } from 'cards/selectors/samples';
import cx from 'classnames';
import styles from './styles.module.less';

export const ToggleLabel = ({ className = '' }) => {
  const multiSampleState = useSelector(getMultiSampleState);
  const { limit } = multiSampleState.count;

  const labelText = multiSampleState.enabled
    ? `Pick ${limit} free sample${limit === 1 ? '' : 's'}`
    : 'Pick free sample designs';

  return <div className={cx(styles.toggleLabelBox, className)}>{labelText}</div>;
};

export default ToggleLabel;
